import React, { useEffect, useState } from 'react';
import { InputAdornment } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Form from 'global/components/form';
import { CancelIconButton, Container, TopBottomSpacingField } from './styles';

export const Language = {
  sp: 'Spanish',
  fr: 'French',
  de: 'German',
  zh: 'Chinese',
  ar: 'Arabic',
  ru: 'Russian',
  ko: 'Korean',
};

const TranslationManager = (props) => {
  const { isEditMode, modifiedLanguageData, setModifiedLanguageData } = props;
  const [availableLanguages, setAvailableLanguages] = useState(Object.keys(Language));

  useEffect(() => {
    setAvailableLanguages(Object.keys(Language).filter((lang) => !(lang in modifiedLanguageData)));
  }, [modifiedLanguageData]);

  const handleDeleteTranslation = (lang) => {
    setModifiedLanguageData((prevData) => {
      const newData = { ...prevData };
      delete newData[lang];
      return newData;
    });

    setAvailableLanguages((langs) => [...langs, lang]);
  };

  const handleLanguageSelected = (e) => {
    const selectedLanguage = e.target.value;

    setAvailableLanguages((langs) => langs.filter((lang) => lang !== selectedLanguage));

    setModifiedLanguageData((prevData) => ({
      ...prevData,
      [selectedLanguage]: '',
    }));
  };

  const handleTranslationTextChange = (lang, value) => {
    setModifiedLanguageData((prevData) => ({
      ...prevData,
      [lang]: value,
    }));
  };

  return (
    <Container>
      <Form
        showNavigation={false}
        screens={[
          {
            inputs: [
              ...(Object.entries(modifiedLanguageData).length > 0 ?
              [{
                id: 'translationManager',
                style: { paddingTop: 0, marginBottom: 0 },
                component: () => (
                  <>
                    {Object.entries(modifiedLanguageData).map(([lang, desc]) => (
                      <TopBottomSpacingField
                        key={lang}
                        label={Language[lang]}
                        disabled={!isEditMode}
                        variant={isEditMode ? 'outlined' : 'standard'}
                        onChange={(e) => handleTranslationTextChange(lang, e.target.value)}
                        multiline
                        fullWidth
                        placeholder="Enter translation here..."
                        value={desc}
                        slotProps={{
                          input: isEditMode
                            ? {
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <CancelIconButton onClick={() => handleDeleteTranslation(lang)}>
                                      <CloseIcon />
                                    </CancelIconButton>
                                  </InputAdornment>
                                ),
                              }
                            : undefined,
                        }}
                      />
                    ))}
                  </>
                ),
              }] : []),
              ...(isEditMode
                ? [
                    {
                      id: 'addNewTranslation',
                      type: 'Select',
                      data: availableLanguages.map((langCode) => ({
                        value: langCode,
                        title: Language[langCode],
                      })),
                      props: {
                        label: 'Add New Language',
                        onChange: handleLanguageSelected,
                        disabled: !isEditMode,
                      },
                    },
                  ]
                : []),
            ],
          },
        ]}
      />
    </Container>
  );
};

export default TranslationManager;
